import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { IReleaseLetterMainState } from '../ReleaseLetterDialog';
import { sendReleaseLetter } from '../../../../../redux/project/documents/sliceProjectDocumentAddReleaseLetter';
import { IAppReduxStore } from '../../../../../redux/store';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({ mainState, hasError, onClose }: IReleaseLetterDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'releaseLetterDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const params = useParams();

    const { replicaId } = params;

    const { data: documents } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );
    const { isLoading } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocumentsAddReleaseLetter,
    );

    const onAdd = () => {
        dispatch(
            sendReleaseLetter({
                ...mainState,
                replicaId,
            }),
        );
    };

    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onAdd}
                sx={buttonSx}
                disabled={!documents.length || isLoading || hasError}
            >
                {t('ctaAdd')}
            </Button>
        </DialogActions>
    );
};

interface IReleaseLetterDialogActionsProps {
    mainState: IReleaseLetterMainState;
    hasError: boolean;
    onClose: () => void;
}
